import React, {StrictMode} from "react";
import {GenerationListItem} from "@App/Components/Vehicletree/GenerationList";
import {Generation} from "@App/types";

type GenerationListItemGroupProps = {
    name: string,
    group: Generation[]
    onClick: (generation: Generation) => void
}

export const GenerationListItemGroup = React.memo<GenerationListItemGroupProps>((props: GenerationListItemGroupProps) => {
    return (
        <StrictMode>
            <div className={'my-3 text-primary font-bold'}>
                {props.name}
            </div>
            <div>
                {props.group && props.group.map(generation => (
                    <GenerationListItem
                        key={generation.id}
                        generation={generation}
                        onClick={props.onClick}
                    />
                ))}
            </div>
        </StrictMode>
    )
})
